// =============================================================
//  TESTI E NUMERI DELLE NUOVE SEZIONI
//  Per aggiornare il sito modifica solo questo file:
//  i componenti leggono tutto da qui.
//
//  Foto: importa l'immagine in cima al file, per esempio
//    import ritratto from "../assets/agnese.jpg";
//  (sotto la riga "import type ...") e metti la variabile al posto di null (es. foto: ritratto).
//  Finché resta null, al suo posto si vede un riquadro segnaposto.
// =============================================================

import { ChiSonoContent, LavoriContent, ServiziContent } from "../screen/nuove-sezioni/types";
import sitomobile from "../assets/fisiotrain/sitomobile.png";
import storyfisio from "../assets/fisiotrain/storyfisio.png";
import reelfisio from "../assets/fisiotrain/reelfisio.png";
import lagogarda from "../assets/boldtrekkers/lagogarda.jpeg";
import sanmartino from "../assets/boldtrekkers/sanmartino.jpeg";
import matite from "../assets/parcosojo/matite.jpeg";
import reel from "../assets/parcosojo/reel.jpeg";
import bimbi from "../assets/parcosojo/bimbi.jpeg";
// import type { ChiSonoContent, ServiziContent, LavoriContent } from "../types/content";

export const chiSono: ChiSonoContent = {
  etichetta: "Chi sono",
  saluto: "Ciao, sono",
  nome: "Agnese.",
  frase:
    "Content creator e social media specialist. Trasformo brand, luoghi e persone in contenuti che generano attenzione, community e risultati misurabili.",
  testo:
    "Da più di otto anni racconto luoghi, persone e brand attraverso i social. Ho fatto un giro largo per arrivarci: arte, televisione, fotografia, codice. Ogni tappa mi ha lasciato qualcosa che oggi metto nei contenuti che creo.",
  foto: null, // es. import ritratto from "../assets/agnese.jpg"  →  foto: ritratto
  adesivi: ["Social media", "Video"],

  storiaTitolo: "La mia storia,",
  storiaTitoloCorsivo: "in quattro capitoli",
  storiaIntro: "Nessun percorso dritto, ma ogni deviazione è finita nel mio modo di lavorare.",
  capitoli: [
    {
      titolo: "Lo sguardo",
      testo:
        "Il DAMS a Padova, poi la formazione in Fabrica tra Photoshop, Illustrator e Cinema 4D, fino a creare un capo d’abbigliamento virtuale ispirato al Bauhaus. Poi la post produzione still-life per l’e-commerce di Benetton.",
      quando: "2015 — 2021 · Padova, Treviso",
    },
    {
      titolo: "Il racconto",
      testo:
        "A Tv7 Triveneta ho montato programmi e servizi giornalistici partendo da riprese e voice-over. Lì ho imparato a dare un ritmo alle immagini e a dire tanto in pochi secondi.",
      quando: "2020 — 2021 · Padova",
    },
    {
      titolo: "Il codice",
      testo:
        "Mi affascinava costruire interfacce e vederle diventare un prodotto finito. Dal corso Flutter alla Rawfish come frontend developer: tre anni a progettare e sviluppare siti e app.",
      quando: "2020 — 2024 · Vicenza",
    },
    {
      titolo: "I social",
      testo:
        "La passione di sempre: provare strategie per portare le persone a scoprire un posto. È iniziata con il Parco del Sojo, è cresciuta con Mondiali.it e Bold trekkers. Oggi è il mio lavoro.",
      quando: "dal 2018 · oggi",
      evidenza: true,
    },
  ],

  citazione:
    "Un buon contenuto non si limita a farsi guardare: fa venire voglia di andarci, di provarlo, di scriverti.",
  firma: "Agnese",

  comeLavoro: [
    {
      titolo: "Ascolto prima di creare",
      testo: "Capisco chi sei, a chi parli e cosa vuoi ottenere. Solo dopo accendo la fotocamera.",
    },
    {
      titolo: "Costanza, prima di tutto",
      testo:
        "Un calendario editoriale chiaro e pubblicazioni regolari: è così che una community cresce davvero.",
    },
    {
      titolo: "Provo, misuro, miglioro",
      testo:
        "Leggo gli insights ogni mese e cerco sempre nuovi strumenti, anche di AI, per fare meglio e più in fretta.",
    },
    {
      titolo: "In squadra con te",
      testo:
        "Comunicazione diretta, idee condivise e nessuna sorpresa: lavoro bene quando lavoriamo insieme.",
    },
  ],
};

export const servizi: ServiziContent = {
  titolo: "Cosa posso fare",
  titoloCorsivo: "per il tuo brand",
  intro:
    "Dall’idea al contenuto pubblicato, fino ai numeri del mese dopo. Lavoro con aziende, attività locali e progetti che hanno qualcosa da raccontare.",
  // stile: "chiaro" | "colore" | "tratteggio"
  // icona: "reel" | "calendario" | "target" | "web"
  lista: [
    {
      numero: "01",
      titolo: "Content creation",
      testo:
        "Reel, caroselli e stories pensati per essere guardati fino alla fine. Dallo storyboard alle riprese, fino al montaggio e alla didascalia.",
      tag: ["Reel", "Caroselli", "Foto & video", "CapCut · Premiere"],
      icona: "reel",
      stile: "chiaro",
    },
    {
      numero: "02",
      titolo: "Social media management",
      testo:
        "Piano editoriale, pubblicazione costante e gestione della community. Ogni mese un report chiaro su cosa funziona e cosa migliorare.",
      tag: ["Calendario editoriale", "Meta Business Suite", "Report mensili"],
      icona: "calendario",
      stile: "colore",
    },
    {
      numero: "03",
      titolo: "Strategia & ADV",
      testo:
        "Obiettivi, target e inserzioni Facebook e Instagram mirate per portare persone reali, online e sul posto. Con i dati sempre sotto controllo.",
      tag: ["Meta Ads", "Target", "Analytics"],
      icona: "target",
      stile: "chiaro",
    },
    {
      numero: "+ in più",
      titolo: "E quando serve, anche il sito",
      testo:
        "Siti WordPress e React disegnati in Figma, coerenti con la tua identità social. Un solo stile, dal feed alla homepage.",
      tag: ["Figma", "WordPress", "React"],
      icona: "web",
      stile: "tratteggio",
    },
  ],
};

export const lavori: LavoriContent = {
  titolo: "Lavori",
  titoloCorsivo: "selezionati",
  intro: "Obiettivo, strategia, risultati. Numeri veri, presi dagli insights.",

  inEvidenza: {
    tag: ["Progetto personale", "Instagram · Reel"],
    titolo: "Bold trekkers",
    testo:
      "Un progetto social nato con un gruppo di amiche per raccontare la montagna: itinerari, panorami e consigli pratici di trekking. Reel autentici, didascalie curate, crescita solo organica.",
    numeri: [
      { valore: "170K+", label: "visualizzazioni organiche", evidenza: true },
      { valore: "678", label: "nuovi follower da 2 reel" },
    ],
    link: { testo: "Leggi il case study", url: "#bold-trekkers" }, // cambia con l'indirizzo della pagina
    reel: [
      {
        etichetta: "LAGO DI GARDA",
        numero: "173.924",
        dettaglio: "views · 3.495 salvataggi",
        cover: lagogarda,
        segnaposto: "cover reel · Sentiero del Ventrar",
      },
      {
        etichetta: "SAN MARTINO",
        numero: "52.400",
        dettaglio: "views · 346 condivisioni",
        cover: sanmartino,
        segnaposto: "cover reel · Rifugio Pradidali",
      },
    ],
  },

  // stile: "colore" | "pop" | "chiaro"
  progetti: [
    {
      titolo: "Mondiali.it",
      tag: ["Social + sito", "Replatz"],
      testo:
        "Mi sono occupata di aggiornare l'intero sito in wordpress e di creare i contenuti ovvero gli articoli delle varie discipline sportive. Successivamente mi sono occupata anche di creare i contenuti social delle varie piattaforme.",
      stile: "colore",
      numeri: [
        { valore: "4 mln", label: "visualizzazioni" },
        { valore: "54.796", label: "interazioni (da 32)" },
        { valore: "7.309", label: "visite al sito (da 129)" },
        { valore: "0 → 907", label: "follower" },
      ],
    },
    {
      titolo: "Parco del Sojo",
      tag: ["Social · ADV", "dal 2018"],
      testo:
        "Parco d’arte in montagna a Lusiana. Dal 2018 curo la comunicazione social: piano editoriale, reel e stories che raccontano il parco a famiglie, scuole e appassionati di trekking, e campagne Meta mirate per portare più visitatori nel weekend.",
      stile: "pop",
      immagini: [
        { src: matite, segnaposto: "foto feed" },
        { src: reel, segnaposto: "foto feed" },
        { src: bimbi, segnaposto: "foto feed" },
      ],
      formato: "feed",
    },
    {
      titolo: "Fisiotrain",
      tag: ["Brand · Social · Sito"],
      testo:
        "Centro multidisciplinare di fisioterapia a Breganze. Ho seguito il progetto dall’inizio: prima la progettazione UI/UX in Figma, poi lo sviluppo del sito in React, completamente custom. Oggi gestisco i social con la stessa identità visiva, con caroselli divulgativi e reel che presentano i professionisti.",
      stile: "chiaro",
      immagini: [
        { src: reelfisio, segnaposto: "reel presentazione" },
        { src: storyfisio, segnaposto: "carosello" },
        { src: sitomobile, segnaposto: "sito mobile", adatta: "intera" },
      ],
      formato: "verticale",
    },
  ],

  anche: {
    titolo: "Anche web & UI",
    voci: [
      { nome: "WSalute", dettaglio: "redesign Figma + sviluppo" },
      { nome: "Fisiotrain", dettaglio: "sito React custom" },
      { nome: "Replatz", dettaglio: "UI/UX sito" },
    ],
    link: { testo: "Chiedimi il portfolio web", url: "#contatti" },
  },
};
